'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { useQueryClient } from '@repo/tanstack/query';
import { LOADS_PAGE_SIZE } from '@/app/@protected/loads/(table)/_utils/loads-query-params.ts';
import { ACTIVE_STATUSES } from '@/app/@protected/loads/(table)/_utils/loads-tabs.ts';

// The first page of the default Loads list: the Active tab, newest first.
const DEFAULT_LOADS_LIST_PARAMS = {
  'filter[status_alias]': ACTIVE_STATUSES.join(','),
  page: 1,
  perPage: LOADS_PAGE_SIZE,
  'sort[created_at]': 'desc'
};
export const usePrefetchLoadsList = () => {
  const $ = _c(3);
  const api = useApi();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== api.loads.list || $[1] !== queryClient) {
    t0 = () => {
      queryClient.prefetchQuery(api.loads.list.queryOptions({
        input: DEFAULT_LOADS_LIST_PARAMS
      }));
    };
    $[0] = api.loads.list;
    $[1] = queryClient;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};